import React from 'react';
import { Box } from '@mui/material';

const SCALE_MIN = 0.5;
const SCALE_MAX = 1.5;

const DEFAULT_SCALE = 0.75;

function clampScale(scale: number | undefined): number {
  if (scale == null || Number.isNaN(scale)) return DEFAULT_SCALE;
  return Math.min(SCALE_MAX, Math.max(SCALE_MIN, scale));
}

/**
 * Zooms widget body content (map, charts, text) within the card without changing grid size.
 */
const ScaledWidgetContent: React.FC<{ scale?: number; children: React.ReactNode }> = ({
  scale,
  children,
}) => {
  const s = clampScale(scale);
  if (Math.abs(s - 1) < 0.01) {
    return <>{children}</>;
  }

  return (
    <Box
      sx={{
        position: 'relative',
        flex: 1,
        minHeight: 0,
        minWidth: 0,
        width: '100%',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: `calc(100% / ${s})`,
          height: `calc(100% / ${s})`,
          transform: `scale(${s})`,
          transformOrigin: 'top left',
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
        }}
      >
        <Box sx={{ flex: 1, minHeight: 0, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default ScaledWidgetContent;
